import styled from "styled-components";
const fontSize = localStorage.getItem('fontSize');
// export const ButtonContainer = styled.button`
//   background-color: #62aa51;
//   width: 159px;
//   height: 51px;
//   &:hover {
//     opacity: 0.8;
//   }
//   color: #ffffff;
// `;

export const SubTitle = styled.span`
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 700;
  font-size: calc(${fontSize} + 4px);
  color: #101E8E;
`;

export const Paragraph = styled.span`
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: calc(${fontSize} - 2px);
  color: #101E8E;
  text-align: center
`;